module.exports = __webpack_public_path__ + "img/cog-orange-outline.c8ff2483.svg";